import _ from "lodash";
import * as React from "react";
import { formatDate } from "../../../classes/DateHelper";
import { htmlToText } from "../../../classes/StringHelper";
import { IConfig } from "../../../Config";
import SimpleButton from "../../RenderComponents/SimpleButton";

interface IProps {
    config: IConfig;
    settings: any;
    recentNews: any[];
    getRecentPostUrl: (newsId: string) => string;
    onReadRecentPost: (newsId: string) => void;
    buttonClassName?: string;
    buttonType?: "a" | "button";
    buttonText?: string;
    buttonTitle?: string;
    buttonAriaLabel?: string;
}

export default (props: IProps) => {
    return props.settings.ShowRecentPosts && props.recentNews.length > 0 ? <>
        <div className="CMS_e_row">
            <div className="CMS_subsection">
                <ul className="NR_sidePosts">
                    {_.map(props.recentNews, (news, index) => {
                        return (
                            <li
                                className="NR_item"
                                key={`news-${index}`}
                                style={{
                                    marginBottom: index < props.recentNews.length - 1 ? "15px" : "0",
                                    minHeight: "auto",
                                }}
                            >
                                {!_.isEmpty(news.featuredImage) ? <div className="NR_featured-image">
                                    <img src={`${_.trimEnd(props.config.cdnLocation, "/")}${news.featuredImage}`} alt={news.featuredImageCaption} />
                                </div> : <div className="NR_featured-image no-image" title={`Image for ${news.title}`}></div>}
                                <div className="NR_title CMS_title CMS_T6">{news.title}</div>
                                <div className="NR_publishDate">
                                    <span className="NR_RP_date">{formatDate(news.scheduledDate)}</span>
                                    {props.settings.ShowAuthor ? <>
                                        <span className="NR_RP_by"> - by </span>
                                        <span className="NR_RP_author">{news.author}</span>
                                    </> : null}
                                </div>
                                <div className="NR_summary truncate">{_.truncate(htmlToText(news.summary), {
                                    length: 250,
                                    separator: /,? +/,
                                })}</div>
                                <SimpleButton
                                    className={props.buttonClassName || "NR_itemLink CMS_button CMS_bAction"}
                                    type={props.buttonType}
                                    title={props.buttonTitle || `Read more about ${news.title}`}
                                    ariaLabel={props.buttonAriaLabel || `Read more about ${news.title}`}
                                    href={props.getRecentPostUrl(news.newsId)}
                                    onClick={async (e) => {
                                        e.preventDefault();
                                        props.onReadRecentPost(news.friendlyUrlName);
                                    }}
                                >
                                    {props.buttonText || "Read more"}
                                </SimpleButton>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    </> : null;
};
